module.exports = __webpack_public_path__ + "static/media/ls7.5f9a7770.svg";